import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { apiQuery } from "../../utils/api-config";
import { Response } from "../../types/response/Response";
import {
  AccountCreateDTO,
  AccountDTO,
  AccountEditDTO,
} from "../../types/account/AccountDTO";

export const accountApi = createApi({
  reducerPath: "account",
  baseQuery: apiQuery,
  tagTypes: ["accounts", "accounts-notification"],
  endpoints: (builder) => ({
    getAccount: builder.query<Response<AccountDTO[]>, void>({
      query: () => "/accounts",
      providesTags: ["accounts"],
    }),
    createAccount: builder.mutation<void, Partial<AccountCreateDTO>>({
      query: (body) => ({
        url: "/accounts",
        method: "POST",
        body,
      }),
      invalidatesTags: ["accounts"],
    }),
    editAccount: builder.mutation<void, Partial<AccountEditDTO>>({
      query: (body) => ({
        url: `/accounts/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["accounts"],
    }),
    synchronize: builder.mutation<void, Partial<void>>({
      query: (body) => ({
        url: "/accounts/sync",
        method: "POST",
        body,
      }),
      invalidatesTags: ["accounts"],
    }),
    synchronizeByID: builder.mutation<void, Partial<number | undefined>>({
      query: (id) => ({
        url: `/accounts/${id}/sync`,
        method: "POST",
      }),
      invalidatesTags: ["accounts"],
    }),
  }),
});

export const {
  useGetAccountQuery,
  useCreateAccountMutation,
  useEditAccountMutation,
  useSynchronizeMutation,
  useSynchronizeByIDMutation,
} = accountApi;
